import { createSlice } from "@reduxjs/toolkit";

export const emailSlice = createSlice({
  name: "email",
  initialState: {
    getEmailResult: false,
    getEmailLoading: false,
    getEmailError: false,
    addEmailResult: false,
    addEmailLoading: false,
    deleteEmailResult: false,
  },
  reducers: {
    emailReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_EMAIL":
          return {
            ...state,
            getEmailResult: payload.data,
            getEmailLoading: payload.loading,
            getEmailError: payload.error,
          };
        case "ADD_EMAIL":
          return {
            ...state,
            addEmailResult: payload.data,
            addEmailLoading: payload.loading,
          };
        case "DELETE_EMAIL":
          return {
            ...state,
            deleteEmailResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { emailReducers } = emailSlice.actions;

export default emailSlice.reducer;
